<div class="tennis-spinner" [class]="size">
  <div #spinnerContainer [innerHTML]="svgContent"></div>
</div>
